import React, { Component, createRef } from 'react';
import './Options.css';
import Lightbox from '../utility/Lightbox';
import MainButton from '../buttons/MainButton';
import User from '../../User';
import Changelog from './Changelog';

import { read, getLanguage, setLanguage } from '../../TextManager';
import { getVolume, setVolume } from '../../SoundManager';

const fetishCharacters = [
  { key: 1, name: "Amber" },
  { key: 2, name: "Ruby" },
  { key: 3, name: "Pearl" },
  { key: 4, name: "Beryl" },
  { key: 5, name: "Spinelle" }
];

export default class Options extends Component {

  constructor(props) {

    super(props);
    this.fileInputRef = createRef();
  }

  state = {
    changelog: null,
    status: null,
    confirm: null,
    isFullscreen: !!document.fullscreenElement // Detect initial fullscreen state
  }

  changeLanguage(language) {
    if (getLanguage() !== language) {
      setLanguage(language);
      window.location.reload(false);
    }
  }

  toggleFullscreen = () => {
    // Enter or exit fullscreen based on current state
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        this.setState({ isFullscreen: true });
      }).catch(err => {
        console.error('Error attempting to enter fullscreen mode:', err);
      });
    } else {
      document.exitFullscreen().then(() => {
        this.setState({ isFullscreen: false });
      }).catch(err => {
        console.error('Error attempting to exit fullscreen mode:', err);
      });
    }
  }

  componentDidMount() {
    // Listen to fullscreen changes
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
  }

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
  }

  handleFullscreenChange = () => {
    this.setState({ isFullscreen: !!document.fullscreenElement });
  }

  changeFetishMode(champion, mode) {
    if (User.fetishModeFor(champion) !== mode) {
      User.setFetishMode(champion, mode);
      this.forceUpdate();
    }
  }

  render() {

    let language = getLanguage();

    let music = getVolume('music') * 10;
    let sfx = getVolume('sfx') * 10;

    let slowmode = localStorage.getItem("options.slowmode");

    return (
      <div className={"nav-item nav-options" + (this.props.concede ? " game-options" : "")}>
        <Lightbox className="small options-lightbox" open={this.state.status === "options"} onClose={() => this.setState({ status: null })}>
          <div className="options-box">
            <h1>{read('nav/options')}</h1>
            <div className="options-row">
              <div className="options-param">{read('nav/music')}</div>
              <div className="options-value">{[...Array(11).keys()].map(i => <div key={i} onClick={() => { setVolume(i / 10, 'music'); this.forceUpdate(); }} className={"options-audio-tick" + (music >= i ? " audio-tick-active" : "")} />)}</div>
            </div>
            <div className="options-row">
              <div className="options-param">{read('nav/sfx')}</div>
              <div className="options-value">{[...Array(11).keys()].map(i => <div key={i} onClick={() => { setVolume(i / 10, 'sfx'); this.forceUpdate(); }} className={"options-audio-tick" + (sfx >= i ? " audio-tick-active" : "")} />)}</div>
            </div>
            {/*<div className="options-row">
              <div className="options-param">{read('nav/fetish')}</div>
              <div className="options-value">
                <div onClick={() => this.setState({ status: "fetish" })} className="options-button">{read('nav/edit')}</div>
              </div>
            </div>*/}
            {/*<div className="options-row">
              <div className="options-param">{ read('nav/language') }</div>
              <div className="options-value">{ read('language') + " /" }&nbsp;<span onClick={() => this.setState({status: "language"})} className="options-button">{ read('nav/changelanguage') }</span></div>
            </div>*/}
            <div className="options-row">
              <div className="options-param">{read('nav/animations')}</div>
              <div className="options-value">
                <div className={"options-radio" + (!slowmode ? " options-button" : "")}
                  onClick={() => {
                    if (!slowmode) {
                      localStorage.setItem('options.slowmode', true);
                      this.forceUpdate();
                    }
                  }}>
                  {read('nav/animationsslow')}</div>&nbsp;/&nbsp;
                <div className={"options-radio" + (slowmode ? " options-button" : "")}
                  onClick={() => {
                    if (slowmode) {
                      localStorage.removeItem('options.slowmode');
                      this.forceUpdate();
                    }
                  }}>
                  {read('nav/animationsfast')}</div>
              </div>
            </div>
            {/*<div className="options-row">
              <div className="options-param">Growth seq.</div>
              <div className="options-value">
                <div className={"options-radio" + (growthsequences !== "none" ? " options-button" : "")}
                  onClick={() => {
                    if (growthsequences !== "none") {
                      localStorage.setItem('options.growthsequences', 'none');
                      this.forceUpdate();
                    }
                  }}>
                  None</div>&nbsp;/&nbsp;
                <div className={"options-radio" + (growthsequences !== "fast" ? " options-button" : "")}
                  onClick={() => {
                    if (growthsequences !== "fast") {
                      localStorage.setItem('options.growthsequences', 'fast');
                      this.forceUpdate();
                    }
                  }}>
                  Fast</div>&nbsp;/&nbsp;
                <div className={"options-radio" + (growthsequences !== "complete" ? " options-button" : "")}
                  onClick={() => {
                    if (growthsequences !== "complete") {
                      localStorage.setItem('options.growthsequences', 'complete');
                      this.forceUpdate();
                    }
                  }}>
                  Full</div>
              </div>
            </div>*/}
            {/* Fullscreen Options */}
            <div className="options-row">
              <div className="options-param">{read('nav/fullscreen')}</div>
              <div className="options-value">
                <div className={"options-radio" + (!this.state.isFullscreen ? " options-button" : "")}
                  onClick={() => {
                    if (!this.state.isFullscreen) {
                      this.toggleFullscreen();
                    }
                  }}>
                  {read('nav/optionsyes')}</div>&nbsp;/&nbsp;
                <div className={"options-radio" + (this.state.isFullscreen ? " options-button" : "")}
                  onClick={() => {
                    if (this.state.isFullscreen) {
                      this.toggleFullscreen();
                    }
                  }}>
                  {read('nav/optionsno')}</div>
              </div>
            </div>
            {/* Patreon Options */}
            <div className="options-row">
              <div className="options-param">{read('nav/membership')}</div>
              <div className="options-value">
                <div className="options-radio">{User.premium ? read('nav/membershipactive') : read('nav/membershipinactive')}</div>
              </div>
            </div>
            <div className="changelog-section" onClick={() => this.setState({ changelog: true })}>News log</div>
            { User.premium ? "" :
              <div className="patreon-section">
                <div className="patreon-link" onClick={() => User.connectWithPatreon()}>{read('nav/patreonclaim')}</div>
                <div className="patreon-info" onClick={() => this.setState({ patreoninfo: true })}>{read('nav/patreoninfo')}</div>
              </div>
            }
            {/* Save Options */}
            <div className="save-buttons">
              <MainButton onClick={() => User.save()}>{read('nav/save')}</MainButton>
              <MainButton onClick={() => this.fileInputRef.current.click()}>{read('nav/load')}</MainButton>
              <input style={{ display: 'none' }} ref={this.fileInputRef} type="file" accept=".save" onChange={e => User.load(e.target.files[0])} />
            </div>
            <div className="concede-button">
              <MainButton onClick={() => this.setState({ confirm: true })} color="red">{read('nav/deletesave')}</MainButton>
            </div>
          </div>
        </Lightbox>
        <Lightbox open={this.state.status === "language"} onClose={() => this.setState({ status: null })}>
          <div className="options-box">
            <h1>{read('nav/language')}</h1>
            <div className="options-warning">{read('nav/languagewarning')}</div>
            <div className="options-row small-row">
              <div onClick={() => this.changeLanguage("en")} className={"options-language" + (language === "en" ? " options-language-current" : "")}>{"English"}</div>
              <div onClick={() => this.changeLanguage("jp")} className={"options-language" + (language === "jp" ? " options-language-current" : "")}>{"日本語"}</div>
            </div>
            <div className="options-row small-row">
              <div onClick={() => this.setState({ status: "options" })} className="options-back">{read('menu/back')}</div>
            </div>
          </div>
        </Lightbox>
        <Lightbox className="small options-lightbox" open={this.state.status === "fetish"} onClose={() => this.setState({ status: "options" })}>
          <div className="options-box">
            <h1>{read('nav/fetishcontent')}</h1>
            <div className="options-info fetish-info">{read('nav/fetishcontentinfo')}</div>
            {fetishCharacters.map(character => {
              let mode = User.fetishModeFor(character.key);
              return (
                <div key={character.key} className="options-row fetish-row">
                  <div className="options-param">{character.name}</div>
                  <div className="options-value">
                    <div className={"options-radio" + (mode !== "mature" ? " options-button" : "")}
                      onClick={() => this.changeFetishMode(character.key, "mature")}>
                      {read('nav/fetishmature')}</div>&nbsp;/&nbsp;
                    <div className={"options-radio" + (mode !== "soft" ? " options-button" : "")}
                      onClick={() => this.changeFetishMode(character.key, "soft")}>
                      {read('nav/fetishsoft')}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </Lightbox>
        <Lightbox open={this.state.confirm} onClose={() => this.setState({ confirm: null })}>
          <div className="options-box">
            <h1>{read('nav/deletesavetitle')}</h1>
            <div className="options-warning">{read('nav/deletesavewarning')}</div>
            <div className="concede-button">
              <MainButton onClick={() => User.clear()} color="red">{read('nav/deletesaveconfirm')}</MainButton>
            </div>
          </div>
        </Lightbox>
        <Lightbox open={this.state.patreoninfo} onClose={() => this.setState({ patreoninfo: null })}>
          <div className="options-box">
            <h1 className="preview-title">{read('nav/patreonbenefitstitle')}</h1>
            <img className="preview-image" src="https://moa-pull.b-cdn.net/assets/ui/previewbenefitsbun.png"/>
            <div className="preview-info">
              <p>{read('nav/patreonbenefitsinfo1')}<br/>{read('nav/patreonbenefitsinfo2')}</p>
              <ul>
                <li>{read('nav/patreonbenefitslist1')}</li>
                <li>{read('nav/patreonbenefitslist2')}</li>
              </ul>
            </div>
            <div className="preview-info preview-warning">{read('nav/patreonbenefitswarning')}</div>
            <MainButton onClick={() => window.open("https://www.patreon.com/NeiNalen", '_blank')} color="patreon">{read('nav/patreon')}</MainButton>
          </div>
        </Lightbox>
        <Changelog manual={this.state.changelog} onClose={() => this.setState({ changelog: null })}/>
        <div onClick={() => this.setState({ status: "options" })} className="options-icon" />
      </div>
    );
  }
}
